<pre>{{ debug | async | json }}</pre>